module.exports = __webpack_public_path__ + "media/img/apple-icon-152x152-5ed97699dbb39650f4aaca0bfef1c0cf.png";